import { Injectable } from "@angular/core";
import { ISavedAddressModel } from "../models/saved-address/saved-address.model";

@Injectable({
    providedIn: 'root'
  })
export class AddressUtilities {
    constructor() {
    }
    public isSavedAddressComplete = (address: ISavedAddressModel): boolean => {

        let a = address.details;

        if(a.name === undefined || a.name === null || a.name === ''){
            return false;
        }
        if(a.addressLine1 === undefined || a.addressLine1 === null || a.addressLine1 === ''){
            return false;
        }
        if(a.postalCode === undefined || a.postalCode === null || a.postalCode === ''){
            return false;
        }
        if(a.countryName === undefined || a.countryName === null || a.countryName === ''){
            return false;
        }
        if(a.countryCode === undefined || a.countryCode === null || a.countryCode === ''){
            return false;
        }
    
        return true
    }
}